import type { EmployeeMonthlyInfo } from '../../types/employee';
import { isBusinessServicePay } from '../../types/employee';

export function netPayFromMonthlyInfo(info: EmployeeMonthlyInfo): number {
  if (isBusinessServicePay(info.employee)) {
    return info.totalSalary - info.totalEmployeeInsurance;
  }
  return (
    info.totalSalary -
    info.totalEmployeeInsurance -
    info.withholdingTax -
    info.localTax
  );
}
